import { ComponentProps, FC } from 'react';

import { cn } from '@/lib/utils';

interface ModalAlertProps extends ComponentProps<'div'> {}

export const ModalAlert: FC<ModalAlertProps> = ({ children, className, ...props }) => {
  return (
    <div
      {...props}
      className={cn(
        'border border-input rounded-lg text-xs text-foreground bg-primary-foreground [&>svg]:text-foreground p-4 mb-4',
        className
      )}
    >
      {children}
    </div>
  );
};
